import React, { useState } from 'react';
import './FaqSection.css';

const FaqSection = ({ faq }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? -1 : index);
  };

  if (!faq || !faq.length) return null;

  return (
    <section className="faq-section container">
      <div className="faq-left">
        <h2>Frequently Asked Questions</h2>
        <p>
          Still need help? <span className="faq-highlight">Get Help Now</span>
        </p>
      </div>

      <div className="faq-right">
        {faq.map((faqItem, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              {index + 1}. {faqItem.question}
              <span className="faq-icon">{activeIndex === index ? '▲' : '▼'}</span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">{faqItem.answer}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FaqSection;
